import { isEmpty } from '@backmarket/utils/object/isEmpty'

export interface Error {
  payload?: {
    errors: Error[]
    data: Record<string, string>
    message: string
    status: number
  }
  status_code: number
  title: string
}

export function getApiErrorMessage(error: Error) {
  if (isEmpty(error.payload)) {
    return error.title
  }
  if (error.payload.status === 400) {
    return error.payload?.errors[0]?.title || ''
  }
  if (error.status_code === 422) {
    return error.payload?.data?.global[0] || ''
  }

  return error.payload.message
}
